
export const normalizeLang = (lang = "tr") => {
  const value = String(lang || "")
    .toLowerCase()
    .replace("_", "-")
    .trim();

  if (value.startsWith("fr")) return "fr";
  if (value.startsWith("de")) return "de";
  if (value.startsWith("tr")) return "tr";
  if (value.startsWith("nl")) return "nl";
  if (value.startsWith("en")) return "en";

  return "tr";
};

const LOCALE_MAP = {
  fr: "fr-FR",
  de: "de-DE",
  tr: "tr-TR",
  nl: "nl-NL",
  en: "en-US",
};

const CURRENCY_POSITION = {
  fr: "suffix",
  de: "suffix",
  tr: "suffix",
  nl: "prefix",
  en: "prefix",
};

export const formatMoneyByLanguage = (amount, lang = "tr") => {
  const normalizedLang = normalizeLang(lang);
  const locale = LOCALE_MAP[normalizedLang] || "tr-TR";
  const safeAmount = Number(amount ?? 0);

  const numberPart = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(safeAmount);

  return CURRENCY_POSITION[normalizedLang] === "prefix"
    ? `€ ${numberPart}`
    : `${numberPart} €`;
};

export default formatMoneyByLanguage;